import { render, staticRenderFns } from "./CadastrarServicoUnidade.vue?vue&type=template&id=a690914a&scoped=true"
import script from "./CadastrarServicoUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarServicoUnidade.vue?vue&type=script&lang=js"
import style0 from "./CadastrarServicoUnidade.vue?vue&type=style&index=0&id=a690914a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a690914a",
  null
  
)

export default component.exports